export default class EstimateItem {
  id: string = "";
  rowUuid: string = "";
  unitName: string = "";
  unitType: string = "";
  unitPrice: number = 0;
  amount: number = 0;
  totalPrice: number = 0;
  unitLoss: number = 0;
  loss: number = 0;
  expenseCategoryId: string = "";
  memo: string = "";
  items: EstimateItem[] = [];
  purchased: boolean = false;
  purchasedRow: boolean = false;
  vendorName: string = "";
  isEditable?: boolean = false;
  tempUuid?: string = "";
  level?: number = 0;
  isFromActualResult?: boolean = false;
}
